var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4042 15.5957C6.80302 16.9946 8.64363 17.8651 10.6124 18.0589C12.5811 18.2527 14.5561 17.7578 16.2009 16.6586C17.8456 15.5594 19.0583 13.9238 19.6322 12.0306C20.2062 10.1375 20.1059 8.10387 19.3485 6.27637C18.591 4.44887 17.2233 2.94057 15.4784 2.0085C13.7335 1.07643 11.7194 0.778274 9.77924 1.16484C7.83913 1.55141 6.0931 2.59878 4.83869 4.12847C3.58428 5.65815 2.89913 7.57549 2.89999 9.55374V11.4499",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.55L2.9 11.45L4.8 9.55M10.5 5.75V10.5H15.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.064887b6ac94d863d3ad2f90e8372ff8.svg";
export { ForwardRef as ReactComponent };